export default "/images/vendor/flag-icon-css/flags/1x1/kw.svg?a3a60802b9df1ea679acbbebbc926483";